export default __webpack_public_path__ + "static/media/bomoh-round-icon.3379c044.svg";